const initState = {
    metrics: null,
    metricsRequestId: null,
    general_dashboard_data: [],
    department_dashboard_data: [],
    departmentDashboardScopeKey: null,
    risk_dashboard_data: [],
    compliance_dashboard_data: [],
    complianceMetrics: null,
    complianceMetricsRequestId: null,
};

const dashboardReducer = (state = initState, action) => {

    switch (action.type) {

        case "RISK_DASHBOARD_DATA":
            return {
                ...state,
                risk_dashboard_data: action.risk_dashboard_data,
            };

        case "DEPARTMENT_DASHBOARD_REQUEST": {
            const nextKey = `dept:${action.department_id ?? 0}`;
            const isScopeChange = nextKey !== state.departmentDashboardScopeKey;
            return {
                ...state,
                department_dashboard_data: isScopeChange ? [] : state.department_dashboard_data,
                departmentDashboardScopeKey: nextKey,
            };
        }

        case "DEPARTMENT_DASHBOARD_DATA":
            if (
                action.scopeKey != null &&
                state.departmentDashboardScopeKey != null &&
                action.scopeKey !== state.departmentDashboardScopeKey
            ) {
                return state;
            }
            return {
                ...state,
                department_dashboard_data: action.department_dashboard_data,
                departmentDashboardScopeKey: action.scopeKey ?? state.departmentDashboardScopeKey,
            };

        case "COMPLIANCE_DASHBOARD_DATA":
            return {
                ...state,
                compliance_dashboard_data: action.compliance_dashboard_data,
            };

        case "GENERAL_DASHBOARD_DATA":
            return {
                ...state,
                general_dashboard_data: action.general_dashboard_data,
            };

        case "METRICS_REQUEST": {
            const isScopeChange =
                action.requestId != null && action.requestId !== state.metricsRequestId;
            return {
                ...state,
                metrics: isScopeChange ? null : state.metrics,
                metricsRequestId: action.requestId,
            };
        }

        case "METRICS":
            if (action.requestId != null && action.requestId !== state.metricsRequestId) {
                return state;
            }
            return {
                ...state,
                metrics: action.metrics,
            };

        case "COMPLIANCE_METRICS_REQUEST": {
            const isScopeChange =
                action.requestId != null && action.requestId !== state.complianceMetricsRequestId;
            return {
                ...state,
                complianceMetrics: isScopeChange ? null : state.complianceMetrics,
                complianceMetricsRequestId: action.requestId,
            };
        }

        case "COMPLIANCE_METRICS":
            if (action.requestId != null && action.requestId !== state.complianceMetricsRequestId) {
                return state;
            }
            return {
                ...state,
                complianceMetrics: action.metrics,
            };



        default:
            return state;
    }
};

export default dashboardReducer;
